import { render } from "./FirstEncounter.vue?vue&type=template&id=2c9a8a08"
import script from "./FirstEncounter.vue?vue&type=script&lang=js"
export * from "./FirstEncounter.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__